import { SimpleSelect } from '@workwave-tidal/core/components'
import { useOptions } from './useOptions'
import { useOnChange } from './useOnChange'
import { useTexts } from './useTexts'
import { Stack } from '@mui/material'

type RecurrenceEndDropdownProps = {
  testId?: string
  type: uui.domain.client.rm.RecurrenceEnd['endType']
}
export function RecurrenceEndDropdown(props: RecurrenceEndDropdownProps) {
  const { type, testId = 'RecurrenceEndDropdown' } = props
  const options = useOptions()
  const texts = useTexts()
  const onChange = useOnChange()

  return (
    <Stack data-testid={testId}>
      <SimpleSelect
        label={texts.label}
        name="recurrenceEndType"
        value={type}
        options={options}
        onChange={onChange}
      />
    </Stack>
  )
}
